import * as React from "react";
import { GripVerticalIcon } from "lucide-react";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "@/lib/utils";

function ResizablePanelGroup({ className, ...props }: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) {
    return (
        <ResizablePrimitive.PanelGroup
            data-slot="resizable-panel-group"
            className={cn(
                "setu:flex setu:h-full setu:w-full setu:data-[panel-group-direction=vertical]:flex-col",
                className
            )}
            {...props}
        />
    );
}

function ResizablePanel({ ...props }: React.ComponentProps<typeof ResizablePrimitive.Panel>) {
    return <ResizablePrimitive.Panel data-slot="resizable-panel" {...props} />;
}

function ResizableHandle({
    withHandle,
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.PanelResizeHandle> & {
    withHandle?: boolean;
}) {
    return (
        <ResizablePrimitive.PanelResizeHandle
            data-slot="resizable-handle"
            className={cn(
                "setu:!bg-border setu:focus-visible:ring-ring setu:relative setu:flex setu:w-px setu:items-center setu:justify-center setu:after:absolute setu:after:inset-y-0 setu:after:left-1/2 setu:after:w-1 setu:after:-translate-x-1/2 setu:focus-visible:ring-1 setu:focus-visible:ring-offset-1 setu:focus-visible:outline-hidden setu:data-[panel-group-direction=vertical]:h-px setu:data-[panel-group-direction=vertical]:w-full setu:data-[panel-group-direction=vertical]:after:left-0 setu:data-[panel-group-direction=vertical]:after:h-1 setu:data-[panel-group-direction=vertical]:after:w-full setu:data-[panel-group-direction=vertical]:after:translate-x-0 setu:data-[panel-group-direction=vertical]:after:-translate-y-1/2 [&[data-panel-group-direction=vertical]>div]:rotate-90",
                className
            )}
            {...props}
        >
            {withHandle && (
                <div className="setu:!bg-border setu:z-10 setu:flex setu:h-4 setu:w-3 setu:items-center setu:justify-center setu:rounded-xs setu:!border">
                    <GripVerticalIcon className="setu:size-2.5" />
                </div>
            )}
        </ResizablePrimitive.PanelResizeHandle>
    );
}

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
